import { AfterViewInit } from '@angular/core';
import { MatTabGroup } from '@angular/material';
import { AgmMap } from '@agm/core';
import { isUndefined } from 'util';
import { Airport } from '../models/airport.model';
var ChartPanelComponent = /** @class */ (function () {
    function ChartPanelComponent() {
    }
    Object.defineProperty(ChartPanelComponent.prototype, "diagramUrl", {
        /**
         * Returns the diagram URL. This will either be a link to the full-size PDF diagram (if available), or the thumbnail
         * generated from terminal procedures.
         * @returns {string}
         */
        get: function () {
            var diagram = this.airport.diagram;
            if (diagram) {
                return diagram.url;
            }
            if (this.airport.hasThumbNail) {
                return this.airport.thumbNail;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    ChartPanelComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Workaround to correctly set the initially selected tab. Wrapped in setTimeout to avoid triggering
        // change detection error ("Expression has changed after it was checked").
        setTimeout(function () {
            _this.selectedTab = _this._getSelectedTab();
        }, 0);
    };
    ChartPanelComponent.prototype.onSelectTab = function (event) {
        this.selectedTab = event.tab;
    };
    ChartPanelComponent.prototype._getSelectedTab = function () {
        var _this = this;
        if (!this.tabGroup._tabs) {
            return null;
        }
        return this.tabGroup._tabs
            .toArray()
            .find(function (tab, i) { return i === _this.tabGroup.selectedIndex; });
    };
    ChartPanelComponent.prototype.onWindowResize = function () {
        var _this = this;
        if (!isUndefined(this.myMap)) {
            this.myMap.triggerResize()
                .then(function () { return _this.myMap._mapsWrapper.setCenter({ lat: _this.airport.location.lat, lng: _this.airport.location.lon }); });
        }
    };
    return ChartPanelComponent;
}());
export { ChartPanelComponent };
